import { ChartPeriodDto, TradingGatewayApiClient } from 'common/api/autogenerated/trading-gateway';

const tradingGatewayApiClient = new TradingGatewayApiClient({
  BASE: '/trading-gateway',
  WITH_CREDENTIALS: true,
});

export const getStocks = () =>
  tradingGatewayApiClient.stockTradingInstruments.getV1StockTradingInstruments(undefined, undefined, undefined, 500);

export const getStocksGroups = () =>
  tradingGatewayApiClient.stockTradingInstruments.getV1StockTradingInstrumentsGroups();

export const getFavoriteStocks = () =>
  tradingGatewayApiClient.stockTradingInstruments.getV1StockTradingInstrumentsFavorites();

export const setFavoriteStocks = (symbol: string) =>
  tradingGatewayApiClient.stockTradingInstruments.postV1StockTradingInstrumentsFavorites(symbol);

export const deleteFavoriteStocks = (symbol: string) =>
  tradingGatewayApiClient.stockTradingInstruments.deleteV1StockTradingInstrumentsFavorites(symbol);

export const getStocksDailyCandles = (symbol: string[]) =>
  tradingGatewayApiClient.stockTradingInstruments.getV1StockTradingInstrumentsCharts(
    symbol,
    23,
    ChartPeriodDto.H1,
    undefined,
    new Date().toISOString(),
  );
